// src/container/index.tsx
import { cn } from "@modootoday/ui-primitives";
import { jsx, jsxs } from "react/jsx-runtime";
var LAYOUT_CLASS = {
  full: "w-full",
  half: "w-full max-w-[50%]",
  compact: "w-full max-w-[360px]"
};
function WidgetContainer({
  title,
  deepLink,
  onDeepLink,
  layout,
  maxHeight,
  className,
  children,
  chromeless = false
}) {
  const hasDeepLink = Boolean(deepLink && onDeepLink);
  if (chromeless) {
    return /* @__PURE__ */ jsxs("div", { className: cn(LAYOUT_CLASS[layout], className), children: [
      hasDeepLink && /* @__PURE__ */ jsxs("div", { className: "mb-1.5 flex items-center justify-between gap-2 px-1", children: [
        /* @__PURE__ */ jsx("p", { className: "truncate text-[12px] font-medium text-muted-foreground", children: title }),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            onClick: () => onDeepLink(deepLink),
            className: cn(
              "shrink-0 text-[11px] font-medium text-primary",
              "transition-opacity hover:opacity-70",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
            ),
            children: "\uC790\uC138\uD788 \uBCF4\uAE30 \u2192"
          }
        )
      ] }),
      children
    ] });
  }
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "rounded-xl border border-border bg-card p-4",
        LAYOUT_CLASS[layout],
        className
      ),
      children: [
        /* @__PURE__ */ jsxs("div", { className: "mb-3 flex items-center justify-between gap-2", children: [
          /* @__PURE__ */ jsx("p", { className: "truncate text-[13px] font-semibold text-foreground", children: title }),
          hasDeepLink && /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              onClick: () => onDeepLink(deepLink),
              className: cn(
                "shrink-0 text-[11px] font-medium text-primary",
                "transition-opacity hover:opacity-70",
                "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30"
              ),
              children: "\uC790\uC138\uD788 \uBCF4\uAE30 \u2192"
            }
          )
        ] }),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(maxHeight && "overflow-y-auto"),
            style: maxHeight ? { maxHeight } : void 0,
            children
          }
        )
      ]
    }
  );
}

export {
  WidgetContainer
};
//# sourceMappingURL=chunk-BFXPDNCR.js.map